import logoIcon from "@/assets/imperative_icon.svg"
import adminLogoIcon from "@/assets/imperative_icon_admin.svg"
import adminLogoIconDark from "@/assets/imperative_icon_admin_dark.svg"

// variant="admin" uses the crimson/pink mark (same as the admin favicon) so
// admin surfaces are visually distinct from the client app: crimson-on-pink
// in light mode, inverted to pink-on-crimson in dark mode.
export default function AppLogo({
  variant = "default",
}: {
  variant?: "default" | "admin"
}) {
  return (
    <>
      <div className="text-sidebar-primary-foreground flex aspect-square size-8 items-center justify-center rounded-md">
        {variant === "admin" ? (
          <>
            <img
              src={adminLogoIcon}
              alt="Imperative"
              className="size-8 rounded-md dark:hidden"
            />
            <img
              src={adminLogoIconDark}
              alt="Imperative"
              className="hidden size-8 rounded-md dark:block"
            />
          </>
        ) : (
          <img src={logoIcon} alt="Imperative" className="size-8 rounded-md" />
        )}
      </div>
    </>
  )
}
